export const loadGoogleTranslate = (callback) => {
  if (document.getElementById('google-translate-script')) {
    if (callback) callback();
    return;
  }

  window.googleTranslateElementInit = function() {
    try {
      const container = document.getElementById('google_translate_element');
      if (!container) return;

      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,zh-CN,hi',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        'google_translate_element'
      );
      
      if (callback) callback();
    } catch (error) {
      console.error('[GoogleTranslate] Error:', error);
    }
  };

  const script = document.createElement('script');
  script.id = 'google-translate-script';
  script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  script.async = true;
  document.body.appendChild(script);
};